import { createAction } from "redux-actions";
import { takeLatest, put, select, call } from "redux-saga/effects";
import axios from "axios";
import moment from "moment";
import { queryParams } from "../../../../../utils/queryParams";

export const SET_LOADING = "./zeroVisits/SET_LOADING";
export const FETCH_CHART_SUCCESS = "./zeroVisits/FETCH_CHART_SUCCESS";
export const FETCH_CURRENT_USER = "./zeroVisits/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS = "./zeroVisits/FETCH_CURRENT_USER_SUCCESS";
export const RESET_FILTER_SELECTED = "./zeroVisits/RESET_FILTER_SELECTED";
export const SET_DATES = "./zeroVisits/SET_DATES";
export const SET_FILTERS_DIRTY = "./zeroVisits/SET_FILTERS_DIRTY";
export const SET_UPDATES_LOADING = "./zeroVisits/SET_UPDATES_LOADING";
export const UPDATE_DATES = "./zeroVisits/UPDATE_DATES";
export const UPDATE_CHART = "./zeroVisits/UPDATE_CHART";
export const RESET_FILTER = "./zeroVisits/RESET_FILTERS";
export const UPDATE_PERIOD_TYPE = "./zeroVisits/UPDATE_PERIOD_TYPE";
export const UPDATE_CUSTOM_RANGE = "./zeroVisits/UPDATE_CUSTOM_RANGE";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  updateDates: createAction(UPDATE_DATES),
  updateData: createAction(UPDATE_CHART),
  resetFilters: createAction(RESET_FILTER),
  updatePeriodType: createAction(UPDATE_PERIOD_TYPE),
  updateCustomRange: createAction(UPDATE_CUSTOM_RANGE)
};
export default function* watchActiveMembers() {
  yield takeLatest(FETCH_CURRENT_USER, fetchCurrentUserData);
  yield takeLatest(UPDATE_CHART, updateData);
  yield takeLatest(RESET_FILTER, resetFilters);
  yield takeLatest(UPDATE_CUSTOM_RANGE, updateCustomRange);
}
export function* fetchCurrentUserData(data) {
  yield put({
    type: FETCH_CURRENT_USER_SUCCESS,
    payload: data.payload
  });
  yield put({ type: SET_LOADING, payload: true });
  yield setDates();
  try {
    yield fetchChart();
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* getCommonApiParams() {
  return yield select((state) => {
    const {
      currentUser: { organizationId, locationId, objectId, regionId },
      selectedRequestDates: { startDate, endDate },
      selectedFilters: { period_type }
    } = state.zeroVisits;
    const period = period_type.toLowerCase();
    if (!organizationId && !locationId && !objectId && !regionId && !startDate && !endDate) return;
    return [organizationId, locationId, objectId, regionId, startDate, endDate, period];
  });
}

export function* fetchChart() {
  yield put({ type: SET_UPDATES_LOADING, payload: true });
  const [organization_id, location_id, object_id, region_id, startDate, endDate, period] =
    yield getCommonApiParams();
  const params = {
    organization_id,
    location_id,
    object_id,
    region_id,
    end_date: endDate,
    start_date: startDate,
    period_type: period
  };
  let url = queryParams.apiVersion + "pages/memberships/zero_visit_members_chart";
  try {
    let { data } = yield call(axios.get, url, { params });
    yield put({ type: FETCH_CHART_SUCCESS, payload: data.data });
    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (err) {
    console.error(err);
  }
}

export function* setDates() {
  const endDate = yield select((state) => state.zeroVisits.currentUser.calendarEndDate);
  const startDate = moment(endDate).startOf("month").subtract(11, "months").format("YYYY-MM-DD");

  yield put({
    type: SET_DATES,
    payload: {
      startDate,
      endDate
    }
  });
}

function* updateData() {
  yield put({ type: SET_UPDATES_LOADING, payload: true });
  try {
    yield put({ type: SET_FILTERS_DIRTY, payload: false });
    yield fetchChart();
    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* resetFilters() {
  yield put({ type: SET_UPDATES_LOADING, payload: true });
  yield setDates();
  yield put({ type: RESET_FILTER_SELECTED });
  try {
    yield fetchChart();
    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}
function* updateCustomRange() {
  yield put({ type: SET_FILTERS_DIRTY, payload: true });
}
